import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import localforage from "localforage";

// index.js
// Check if the service worker is supported by the browser
if ("serviceWorker" in navigator) {
  // Register the service worker
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Error registering Service Worker:", error);
    });
}

// Configure LocalForage (you can do this once in your app setup)
localforage.config({
  driver: localforage.INDEXEDDB, // You can choose the storage driver
  name: "myApp",
  version: 1.0,
  storeName: "keyvaluepairs", // Corrected property name
});

// import localforage from "localforage";

// localforage.config({
//   driver: localforage.INDEXEDDB, // You can choose the storage driver
//   name: "myApp",
//   version: 1.0,
//   storeName: "keyvaluepairs",
// });
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// serviceWorker.register();
